import React, { createContext, useCallback, useContext, useMemo } from 'react'
import { useModalize } from 'react-native-modalize'

import BottomSheet from '@common/components/BottomSheet'
import ReceiveSheetContent from '@common/modules/receive/components/ReceiveSheet/ReceiveSheetContent'

type ReceiveSheetContextType = {
  /** Open the receive popup (overlay modal, no route change). */
  openReceive: () => void
  closeReceive: () => void
}

const ReceiveSheetContext = createContext<ReceiveSheetContextType>({
  openReceive: () => {},
  closeReceive: () => {}
})

export const ReceiveSheetProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { ref: sheetRef, open, close } = useModalize()

  const value = useMemo<ReceiveSheetContextType>(
    () => ({ openReceive: () => open(), closeReceive: () => close() }),
    [open, close]
  )

  return (
    <ReceiveSheetContext.Provider value={value}>
      {children}
      <BottomSheet
        id="receive-sheet"
        sheetRef={sheetRef}
        type="modal"
        closeBottomSheet={close}
        backgroundColor="primaryBackground"
        style={{ maxWidth: 600, width: '90%' }}
        scrollViewProps={{ showsVerticalScrollIndicator: false }}
      >
        <ReceiveSheetContent onClose={close} />
      </BottomSheet>
    </ReceiveSheetContext.Provider>
  )
}

export const useReceiveSheet = () => useContext(ReceiveSheetContext)

export default ReceiveSheetContext
